export class ReportArchives {
  constructor(http) {
    this.http = http;
  }

  create(startDate, endDate) {
    return this.http
      .post('reports/archive', { startDate, endDate })
      .then(response => response.data);
  }

  fetch() {
    return this.http.get('reports/archive').then(response => response.data);
  }

  fetchById(id) {
    return this.http.get(`reports/archive/${id}`).then(response => response.data);
  }

  deleteById(id) {
    return this.http.post(`reports/archive/${id}/delete`).then(response => response.data);
  }

  getАссоuntInfoById(id) {
    return this.http.post(`reports/archive/${id}/info/accounts`).then(response => {
      const pom = document.createElement('a');
      const csvContent = response.data; //here we load our csv data
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      pom.href = url;
      pom.setAttribute('download', 'accounts.csv');
      pom.click();
    });
  }

  getInfoById(id) {
    return this.http.post(`reports/archive/${id}/info`).then(response => {
      const pom = document.createElement('a');
      const csvContent = response.data; //here we load our csv data
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      pom.href = url;
      pom.setAttribute('download', 'oprators.csv');
      pom.click();
    });
  }
}
